import { render } from "./LoadingLabels.vue?vue&type=template&id=07542bd0&scoped=true"
import script from "./LoadingLabels.vue?vue&type=script&lang=js"
export * from "./LoadingLabels.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=07542bd0&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07542bd0"]])

export default __exports__